module.exports = __webpack_public_path__ + "img/star-wars-empire-realty-words.jpg";